import useClickActionHandler from './modules/click-action-handler'
import contact from './modules/contact'
import lightBox from './modules/lightBox'

const onDomReady = {
  default: () => {
    useClickActionHandler()
    lightBox()
    document.querySelectorAll('.js--contact').forEach(contact)
  },
  blog: () => {
    console.log('Run if "<body>" contains class "blog".')
  }
}

const onWindowLoad = {
  default: () => {
    console.log('Run after window load event')
  }
}

// Bootstrap
const run = runners => {
  runners.default()
  Object.keys(runners)
    .filter(key => key !== 'default')
    .forEach(key => {
      if (document.body.classList.contains(key)) {
        runners[key]()
      }
    })
}

document.addEventListener('DOMContentLoaded', () => run(onDomReady))
window.addEventListener('load', () => run(onWindowLoad))
